import { useEffect, useState } from "react";
import axios from "axios";
import apiUrls from "src/api";
import Spinner from "src/common/components/Loader/Spinner";

type MediaObject = {
  thumbnail_s3_url?: string;
  s3_url?: string;
};

type SecuredMedia = {
  source_media_id: number;
  expiration_date_in_ms: number;
  name: string;
  filename: string;
  type: string;
  secured_s3url: string;
  size_in_bytes: number;
  is_private: boolean;
  is_deleted?: boolean;
};

type RoundImagePreviewProps = {
  mediaId_OrIsItAnObjectLol: number | string | MediaObject | null | undefined;
  componentId?: string;
  alt?: string;
  bigger?: boolean;
};

const BROKEN_LINK_PLACEHOLDER =
  "https://d1nhio0ox7pgb.cloudfront.net/_img/g_collection_png/standard/512x512/link_broken.png";

export default function RoundImagePreview({
  mediaId_OrIsItAnObjectLol,
  alt = "",
  bigger = false,
}: RoundImagePreviewProps) {
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const isMediaObject = (val: unknown): val is MediaObject => {
      return (
        typeof val === "object" && val !== null && ("thumbnail_s3_url" in val || "s3_url" in val)
      );
    };

    let isCancelled = false;

    const loadImage = async () => {
      setLoading(true);

      if (!mediaId_OrIsItAnObjectLol) {
        setImageUrl(null);
        setLoading(false);
        return;
      }

      // Case 2: object given directly
      if (isMediaObject(mediaId_OrIsItAnObjectLol)) {
        const url =
          mediaId_OrIsItAnObjectLol.thumbnail_s3_url ||
          mediaId_OrIsItAnObjectLol.s3_url ||
          BROKEN_LINK_PLACEHOLDER;

        setImageUrl(url);
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get<SecuredMedia[]>(
          `${apiUrls.medias.securedMedias}?ids=${encodeURIComponent(
            String(mediaId_OrIsItAnObjectLol),
          )}`,
        );

        if (isCancelled) return;

        const media = response?.data?.[0];
        const url = media?.secured_s3url || BROKEN_LINK_PLACEHOLDER;

        setImageUrl(url);
      } catch {
        if (!isCancelled) {
          setImageUrl(BROKEN_LINK_PLACEHOLDER);
        }
      } finally {
        if (!isCancelled) {
          setLoading(false);
        }
      }
    };

    void loadImage();

    return () => {
      isCancelled = true;
    };
  }, [mediaId_OrIsItAnObjectLol]);

  if (!mediaId_OrIsItAnObjectLol || loading) {
    return <Spinner relative />;
  }

  return (
    <img
      className={`inline object-cover mr-10 sm:ml-4 ${
        bigger ? "w-16 h-16" : "w-12 h-12"
      } mr-2 rounded-full border border-gray-300`}
      src={imageUrl || BROKEN_LINK_PLACEHOLDER}
      alt={alt}
    />
  );
}
